import type { Image } from "@graphql/generated/components";
import { getImageAltTag } from "@lib/utils/attributesUtils";
import type { FC } from "react";
import { memo } from "react";
import { space } from "ui/src/design-tokens";
import type { ReactPlayerProps } from "react-player";
import type { ImageWithVideo } from "@pages/product/[productName]/[articleNumber]/[colorCode]";
import { Box } from "@ui/components/layout/box/Box";
import ProductImage from "./ProductImage";
import { ProductImagesVideo } from "./ProductImagesVideo";

export interface ProductImagesProps {
    images: Image[] | ImageWithVideo[];
    onImageClick: (imageIndex: number) => void;
    imageBackgroundColor?: string;
    imageIndex?: number;
    altTagPattern?: string;
    playerRef?: ReactPlayerProps;
    videoContainerRef?: React.RefObject<HTMLDivElement>;
    productVideo?: string;
}

export const ProductImages: FC<ProductImagesProps> = memo(
    ({ images, onImageClick, imageBackgroundColor, imageIndex, altTagPattern }) => {
        return (
            <Box
                gap={space[0.2]}
                display={["none", "none", "none", "block"]}
                position={"relative"}
                w="100%"
            >
                {images.map((image, index) => {
                    return image.video720 || image.video ? (
                        <ProductImagesVideo
                            key={`product-video-${image.label}`}
                            currentlySelected={imageIndex === index}
                            image={image}
                        />
                    ) : (
                        <ProductImage
                            key={`product-image-${image.label}`}
                            image={image}
                            onImageClick={onImageClick}
                            index={index}
                            imageBackgroundColor={imageBackgroundColor}
                            currentlySelected={imageIndex === index}
                            alt={getImageAltTag(altTagPattern, image.label)}
                            priority={index === 0}
                        />
                    );
                })}
            </Box>
        );
    }
);

ProductImages.displayName = "ProductImages";

export default ProductImages;
